import { Context } from '../..';
import * as base from '../base';

const CONTROLLER = 'agent-responses';

interface AgentResponseRequest {
  companySlug: string;
  searchParams: { query: string | undefined; agentTypeName?: string; maxResults?: number };
}

export interface AgentResponseDto {
  id: string;
  displayName: string;
  agentTypeName: string;
  dateCreated: string;
  rawJsonResponse: string;
  recordCount: number;
}

export interface AgentResponseDetailDto extends AgentResponseDto {
  companySlug: string;
  systemPrompt: string;
  userPrompt: string;
  jsonSchema: string;
}

/**
 * Search for agent responses by text content
 * @param context Overmind context
 * @param payload companySlug and searchParameters
 * @returns List of agent responses matching the search criteria
 */
export async function searchAgentResponses(context: Context, payload: AgentResponseRequest): Promise<AgentResponseDto[] | undefined> {
  const request: base.IRequest = { url: base.aiURL(CONTROLLER, payload.companySlug, `search${base.params(payload.searchParams)}`) };
  const response: base.IResponse<AgentResponseDto[]> = await base.requestWithRetries(request);
  return response.data;
}

/**
 * Get agent response by ID
 * @param context Overmind context
 * @param payload Parameters for fetching a response by ID
 * @returns Detailed agent response
 */
export async function getAgentResponseById(context: Context, payload: { companySlug: string; id: string }): Promise<AgentResponseDetailDto | undefined> {
  const request: base.IRequest = { url: base.aiURL(CONTROLLER, payload.companySlug, payload.id) };
  const response: base.IResponse<AgentResponseDetailDto> = await base.requestWithRetries(request);
  return response.data;
}
